import { lazyLoad } from 'routes/LazyLoad';
import { RouteObject } from 'react-router-dom';
import { PATH } from '../routeConfig';

export const teacherTerminatedContractRoutes: RouteObject[] = [
  {
    path: PATH.TEACHER_TERMINATED_CONTRACT,
    element: lazyLoad(() => import('pages/TeacherTerminatedContract')),
    index: true,
  },
];
